// tickStore.js
export const tickStorage = {
    latest: {} // instrumentToken → tick
};
